import {GET_ALL_TIMEPHASES} from '../actiontypes';
import {API_RESOURCES, createApiReadAction} from '../../util/api';

export function getAllTimephases(engagementId) {
	return createApiReadAction(
		GET_ALL_TIMEPHASES,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.TIMEPHASES]: undefined
		},
		undefined,
		{resolve: true}
	);
}
